import React from 'react'
import { Grid, Icon } from 'semantic-ui-react'
// import Tc_ReturningVehicle from "../../../CBSA_App/components/entrySummaryForms/pga/TC/Tc_ReturningVehicle";
import Input from '../Form/Input/index'
import Button from '../button/Button'
// import { updateData } from "../../../actions/searchContextActions";
import DeleteConfirmation from './deleteComfirmationModal'
import { getValidationError } from '../../../../util'
import { useSelector, useDispatch } from 'react-redux'
import {
  initiate_main_form,
  update_main_form,
} from '../../../../actions/manageProductHistory'
import { DropDown } from '../../../../CBSA_App/components/formComponents/dropDown'
import SearchTabDropDown from '../../../../C88_App/formSections/formComponents/SearchTabDropdown'
import { getDropDownInputText } from '../../../../C88_App/formSections/util/index'
import { cloneDeep } from 'lodash'

const UpdateFormUK = ({
  data,
  updateAPI,
  deleteAPI,
  selectedRowMethod,
  countryDropDownUK,
  formReset,
}) => {
  console.log('update component:', countryDropDownUK)
  const [isOpen, setIsOpen] = React.useState(true)
  const [formOpen, setFormOpen] = React.useState(true)
  const [delConfirm, setdelConfirm] = React.useState(false)
  const prodHistData = useSelector((state) => state.productHistRow)
  const errorJSON = {
    commercialDescription: {
      stateVar: 'prodHistData.productDescription',
      error: '',
    },
    classificationNo: { stateVar: 'prodHistData.HTS', error: '' },
    countryOfOrigin: {
      stateVar: 'prodHistData.lineItemJsonUK.countryOfOrigin',
      error: '',
    },
    commodityCode: {
      stateVar: 'prodHistData.lineItemJsonUK.commodityCode',
      error: '',
    },
    procedure: { stateVar: 'prodHistData.lineItemJsonUK.procedure', error: '' },
    preference: {
      stateVar: 'prodHistData.lineItemJsonUK.preference',
      error: '',
    },
    quotaNumber: {
      stateVar: 'prodHistData.lineItemJsonUK.quotaNumber',
      error: '',
    },
    packageMark: {
      stateVar: 'prodHistData.lineItemJsonUK.packageMark',
      error: '',
    },
  }
  console.log('error Json', errorJSON)
  const [errorState, setErrorState] = React.useState(errorJSON)
  const [isSaving, setIsSaving] = React.useState(false)
  const dispatch = useDispatch()
  console.log('errorState: ', errorState)
  const onChange = (field, value, lineItemJsonUK) => {
    dispatch(update_main_form(field, value, null, null, 'UK', lineItemJsonUK))
  }

  const reset = () => {
    formReset(prodHistData.productLineId, prodHistData.customerId)
  }

  const toggleExpandForm = () => {
    if (isOpen) {
      setIsOpen(false)
    } else {
      setIsOpen(true)
    }
  }

  const toggleFormOn = () => {
    if (formOpen) {
      setFormOpen(false)
    } else {
      setFormOpen(true)
    }
  }

  const fromValidation = () => {
    let flag = 0
    for (let key1 in errorJSON) {
      console.log('fromformvalidation: ', eval(errorJSON[key1].stateVar))
      let err = getValidationError(
        key1,
        eval(errorJSON[key1].stateVar),
        'Item',
        'GB'
      )
      if (err && err[0]) flag = 1
      if (key1 == 'commercialDescription' && err && err[0])
        errorJSON[key1].error = 'Product Description is mandatory'
      else if (key1 == 'classificationNo' && err && err[0])
        errorJSON[key1].error = 'HTS is mandatory'
      else errorJSON[key1].error = err ? err[0] : ''
    }
    setErrorState(errorJSON)
    if (!flag) {
      return true
      // setIsOpen(false)
    }
    return false
  }

  return (
    <div>
      {formOpen && prodHistData.lineItemJsonUK && (
        <div className='update-from-container'>
          <div>
            <div className='stepNumber' onClick={() => toggleExpandForm()}>
              <Icon name={isOpen ? `minus circle` : `plus circle`}></Icon>
              <span>Update Form</span>
            </div>
            <div className='update-close-icon' style={{ float: 'right' }}>
              <Icon
                name='close'
                size='large'
                onClick={() => {
                  toggleFormOn()
                  selectedRowMethod('-2')
                }}
              />
            </div>
            <div className='update-trash-icon' style={{ float: 'right' }}>
              {/* <Icon  name="trash alternate" size="large" onClick={() => {
                            setdelConfirm(true);
                        }} /> */}
              <DeleteConfirmation
                message={
                  <p>
                    Are you sure you want to delete the item with Product
                    Description: <b>{prodHistData.productDescription}</b>
                  </p>
                }
                icon={'trash alternate'}
                delAPI={deleteAPI}
                toggleFormOn={toggleFormOn}
                productLineId={prodHistData.productLineId}
              />
            </div>
          </div>
          {isOpen && (
            <Grid className='kn_form'>
              <br />
              <Grid.Row>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                  <Input
                    name={'productDescription'}
                    showErrorInPopup={true}
                    hasError={
                      errorState.commercialDescription.error
                        ? { message: errorState.commercialDescription.error }
                        : ''
                    }
                    label='Product Description'
                    topLabelClassNames='top-element'
                    value={
                      prodHistData.productDescription
                        ? prodHistData.productDescription
                        : ''
                    }
                    onChange={(field, value) => {
                      onChange(field, value, false)
                    }}
                    onBlur={() => {
                      fromValidation()
                    }}
                  ></Input>
                </Grid.Column>

                <Grid.Column mobile={16} tablet={8} computer={8}>
                  <Input
                    name={'productTag'}
                    label='SKU/Product Tag'
                    value={
                      prodHistData.productTag ? prodHistData.productTag : ''
                    }
                    topLabelClassNames='top-element last-element-row'
                    onChange={(field, value) => {
                      onChange(field, value, false)
                    }}
                    onBlur={() => {
                      fromValidation()
                    }}
                  ></Input>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column mobile={16} tablet={8} computer={3}>
                  {/* <Input name={"countryOfOrigin"} label="Country" value={prodHistData.lineItemJsonUK.countryOfOrigin} topLabelClassNames="top-element" onChange={(field, value) => {onChange(field, value, true)}}  ></Input> */}
                  <SearchTabDropDown
                    label='COUNTRY OF ORIGIN'
                    className='dropdown-element history dropdown100 cbsa-hs-unit-of-measurement'
                    labelClassName='labelEl-dropdown'
                    //labelClass="text-none"
                    data={countryDropDownUK}
                    text={
                      getDropDownInputText(
                        prodHistData.lineItemJsonUK.countryOfOrigin,
                        countryDropDownUK
                      ) || 'Select'
                    }
                    onChange={(value) => {
                      let val = value
                      onChange('countryOfOrigin', val, true)
                    }}
                    onBlur={() => {
                      fromValidation()
                    }}
                  />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={7}>
                  <Input
                    name={'packageMark'}
                    showErrorInPopup={true}
                    hasError={
                      errorState.packageMark.error
                        ? { message: errorState.packageMark.error }
                        : ''
                    }
                    label='Package Mark'
                    topLabelClassNames='top-element'
                    value={
                      prodHistData.lineItemJsonUK.packageMark
                        ? prodHistData.lineItemJsonUK.packageMark
                        : ''
                    }
                    onChange={(field, value) => {
                      onChange(field, value, true)
                    }}
                    onBlur={() => {
                      fromValidation()
                    }}
                  ></Input>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={6}>
                  <Input
                    name={'commodityCode'}
                    showErrorInPopup={true}
                    hasError={
                      errorState.commodityCode.error
                        ? { message: errorState.commodityCode.error }
                        : ''
                    }
                    label='Commodity Code'
                    topLabelClassNames='top-element last-element-row'
                    value={
                      prodHistData.lineItemJsonUK.commodityCode
                        ? prodHistData.lineItemJsonUK.commodityCode
                        : ''
                    }
                    onChange={(field, value) => {
                      onChange(field, value, true)
                    }}
                    onBlur={() => {
                      fromValidation()
                    }}
                  ></Input>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column mobile={16} tablet={8} computer={4}>
                  <Input
                    name={'preference'}
                    showErrorInPopup={true}
                    hasError={
                      errorState.preference.error
                        ? { message: errorState.preference.error }
                        : ''
                    }
                    label='Preference'
                    topLabelClassNames='top-element last-element-col'
                    value={
                      prodHistData.lineItemJsonUK.preference
                        ? prodHistData.lineItemJsonUK.preference
                        : ''
                    }
                    onChange={(field, value) => {
                      onChange(field, value, true)
                    }}
                    onBlur={() => {
                      fromValidation()
                    }}
                  ></Input>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={6}>
                  <Input
                    name={'procedure'}
                    showErrorInPopup={true}
                    hasError={
                      errorState.procedure.error
                        ? { message: errorState.procedure.error }
                        : ''
                    }
                    label='Procedure'
                    topLabelClassNames='top-element last-element-col'
                    value={
                      prodHistData.lineItemJsonUK.procedure
                        ? prodHistData.lineItemJsonUK.procedure
                        : ''
                    }
                    onChange={(field, value) => {
                      onChange(field, value, true)
                    }}
                    onBlur={() => {
                      fromValidation()
                    }}
                  ></Input>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={6}>
                  <Input
                    name={'quotaNumber'}
                    showErrorInPopup={true}
                    hasError={
                      errorState.quotaNumber.error
                        ? { message: errorState.quotaNumber.error }
                        : ''
                    }
                    label='Quota Number'
                    topLabelClassNames='top-element last-element-col last-element-row'
                    value={
                      prodHistData.lineItemJsonUK.quotaNumber
                        ? prodHistData.lineItemJsonUK.quotaNumber
                        : ''
                    }
                    onChange={(field, value) => {
                      onChange(field, value, true)
                    }}
                    onBlur={() => {
                      fromValidation()
                    }}
                  ></Input>
                </Grid.Column>
                {/* <Grid.Column mobile={16} tablet={8} computer={3}>
                            <Input name={"sku"} label="SKU" value={prodHistData.lineItemJsonUK.sku ? prodHistData.lineItemJsonUK.sku : ""} topLabelClassNames="top-element last-element-row last-element-col" onChange={(field, value) => {onChange(field, value, true)}}  ></Input>
                        </Grid.Column> */}
              </Grid.Row>
              <Button
                className='newButton primaryBtn btnType1 mediumBtn'
                onClick={() => {
                  if (fromValidation()) {
                    setIsSaving(true)
                    updateAPI(prodHistData)
                    setTimeout(() => setIsSaving(false), 2000)
                  }
                }}
              >
                {isSaving ? 'Saving...' : 'Save'}
              </Button>
              <Button
                className='newButton secondaryBtn btnType1 mediumBtn'
                onClick={() => {
                  reset()
                }}
              >
                reset
              </Button>
            </Grid>
          )}
        </div>
      )}
    </div>
  )
}

export default UpdateFormUK
